import { Template } from 'common/types/entities/mongo/template'
import { StoreProducts } from 'common/types/entities/store'
import { fetchProductsByProductParam } from 'common/services/list'
import { genProductParam } from 'common/types/params'
import { SubVertical } from 'common/constants'
import { WindowProduct } from 'common/types/entities/mongo/product'
import { fetchBrandById } from 'common/services/brand'

export interface BrandProfile {
  brand: Template
  product: WindowProduct
}

const initialBrandProfile: BrandProfile = {
  brand: null,
  product: null,
}

const FETCH_BRAND = 'brand/FETCH_BRAND'

export const fetchBrandProfile = (templateKey, brandId, curState) => async dispatch => {
  const brand = await fetchBrandById(SubVertical.ART, brandId, {
    templateId: templateKey,
    preview: true,
    key: 'data.windowBrand.value',
  })
  const products: StoreProducts = await fetchProductsByProductParam(
    genProductParam(SubVertical.ART, { brandId, pageSize: 3 }),
  )
  let representativeProduct = null
  if (products && products.products) {
    const productsLength = products.products.length
    representativeProduct = products.products[productsLength - 1]
  }
  dispatch({
    curState,
    brand,
    product: representativeProduct,
    type: FETCH_BRAND,
  })
}

const brandProfileReducer = (state = initialBrandProfile, action) => {
  switch (action.type) {
    case FETCH_BRAND:
      return {
        ...state,
        ...action,
      }
    default:
      return state
  }
}

export default brandProfileReducer
